import {DealStatus} from "@/models/enum/DealStatus";
import {Direction} from "@/models/enum/Direction";

export default interface DealRequestDTO {
    id: string|null;
    takerId: string|null;
    statuses: DealStatus[]|null;
    methods: string[]|null;
    options: string[]|null;
    fromTakerSum: string|null;
    toTakerSum: string|null;
    roundedToTakerSum: string|null;
    currencies: string[]|null;
    fromDate: string|null;
    updatedFromDate: string|null;
    toDate: string|null;
    hasDisputeRequest: string|null;
    disputePaused: string|null;
    onlyMir: string|null;
    traderIds: number[]|null;
    deviceIds: string[]|null;
    storeIds: number[]|null;
    trafficGroupsIds?: number[]|null;
    types: Direction[]|null;
    requisites: string|null;
    userRole: string|null;
}

export const defaultRequestDTO = {
    id: null,
    takerId: null,
    types: [],
    statuses: [],
    fromDate: null,
    toDate: null,
    updatedFromDate: null,
    fromTakerSum: null,
    toTakerSum: null,
    currencies: [],
    methods: [],
    hasDisputeRequest: null,
    disputePaused: null,
    traderIds: [],
    storeIds: [],
    deviceIds: [],
    trafficGroupsIds: [],
    options: [],
    onlyMir: null,
    roundedToTakerSum: null,
    requisites: null,
    userRole: null
} as DealRequestDTO